/**
 * Servicio para pagos con Bold
 */

import apiClient from './api';
import {
  ApiResponse,
  CreatePaymentLinkRequest,
  PaymentLinkCreatedResponse,
} from '../types/sistematizacion.types';

class PaymentService {
  /**
   * Crea un link de pago con Bold
   */
  async createBoldPaymentLink(
    request: CreatePaymentLinkRequest
  ): Promise<ApiResponse<PaymentLinkCreatedResponse>> {
    const response = await apiClient.post<ApiResponse<PaymentLinkCreatedResponse>>(
      '/Payment/bold/link',
      request
    );
    return response.data;
  }

  /**
   * Redirige al usuario al link de pago de Bold
   */
  redirectToPayment(paymentUrl: string): void {
    window.location.href = paymentUrl;
  }

  /**
   * Abre el link de pago en una nueva ventana
   */
  openPaymentInNewWindow(paymentUrl: string): Window | null {
    return window.open(paymentUrl, '_blank', 'noopener,noreferrer');
  }
}

export const paymentService = new PaymentService();
export default paymentService;
